/**
 * AuthCallback Store - State management for AuthCallback.tsx page
 *
 * Related page: frontend/src/pages/AuthCallback.tsx
 *
 * This store provides the route loader for OAuth callback processing.
 */

import { redirect } from 'react-router-dom'
import { authClient } from '../client'
import { tokenStorage, inIframe } from 'txom-frontend-libs'
import { pageLinks } from '../../pageLinks'
import { resetQueryClient } from '../../queryClient'
import { createStore } from 'jotai'

type Store = ReturnType<typeof createStore>

// ============================================================================
// ROUTE LOADERS
// ============================================================================

export async function loader(store: Store) {
  // Verify OAuth callback
  const code = new URLSearchParams(window.location.search).get('code')
  if (code) {
    const response = await authClient.oneTimeToken.verify({ token: code })
    if (!response.error && inIframe && response.data?.session?.token) {
      tokenStorage.save(response.data.session.token)
    }
  }
  // Clear query cache to refresh current user state
  store.set(resetQueryClient)
  return redirect(pageLinks.global_shortcut_home())
}
